// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_enum-bug-keys.js
// module id = 91
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11